export enum CurlSeekResult {
  OK = 0,
  FAIL = 1,
  CANTSEEK = 2
}
